import { I18nLocales, ILocales } from '@/interfaces/locales.interfaces';
import { getCountryCodeFromLocale } from '@/lib/getCountryCodeFromLocale';

export type PageDataType = {
    attributes: PageDataAttributesType;
} | null;

type PageDataAttributesType = {
    locale: I18nLocales | undefined;
    slug: string;
    title: string;
    parentPage: {
        data: PageDataType;
    };
};

type PageHierarchyListType = {
    level: number;
    countryCode: ILocales | undefined;
    title: string;
    slug: string;
};

export function getPageHierarchyList(data: PageDataType, countryCode?: ILocales, level = 0): PageHierarchyListType[] {
    if (!data?.attributes) {
        return [];
    }
    const { locale, slug, parentPage, title } = data.attributes;
    const countryCodeFromLocale = getCountryCodeFromLocale(locale);
    const validCountryCode = countryCode || countryCodeFromLocale;
    const parentList = getPageHierarchyList(parentPage?.data, validCountryCode, level + 1);
    const breadCrumbObj = {
        level,
        countryCode: validCountryCode,
        title,
        slug,
    };
    return parentList.concat(breadCrumbObj);
}
